import React, { useState, useEffect } from 'react';
import './SoftwareEngineering.css';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header';

const Playground = () => {
  const [typedText, setTypedText] = useState('');
  const [showCards, setShowCards] = useState(false);
  const textToType = `Leet's look at some of the things I have been working on and reading about.`;

  useEffect(() => {
    const characters = textToType.split('');
    let currentIndex = 0;
    let timer: NodeJS.Timeout;

    const typeNextChar = () => {
      if (currentIndex < characters.length - 1) {
        setTypedText(text => text + characters[currentIndex]);
        currentIndex++;
      } else {
        clearInterval(timer);
        setTimeout(() => {
          setShowCards(true);
        }, 1500);
      }
    };

    timer = setInterval(typeNextChar, 50);

    return () => clearInterval(timer);
  }, [textToType]);

  const terminalVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    exit: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };

  const chatVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
  };

  const cardVariants = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5, staggerChildren: 0.2 } },
    exit: { opacity: 0, y: 50, transition: { duration: 0.3 } },
  };

  const cardItemVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    exit: { opacity: 0, y: 20, transition: { duration: 0.3 } },
  };

  const [response, setResponse] = useState('');

  const cardData = [
    {
      title: ".net Rules Engine",
      description: "Lately we have been working on a .net rules engine. It is a powerful tool that allows you to create workflows with multiple rules and parameters. The package is open source.",
      link: "https://github.com/microsoft/RulesEngine",
      linkText: "Read More on Github",
      cardImage: "nuget.jpg"
    },
    {
      title: "Typescript Complier",
      description: "In March of 2025 Microsoft announced they are reworking the Typescript compiler and using GO as the language of choice.",
      link: "https://devblogs.microsoft.com/typescript/typescript-native-port/",
      linkText: "Read More on Devblogs",
      cardImage: "typescript.png"
    },
    {
      title: "Motion.dev",
      description: "I am someone who spends most of my time writing code for the backend. As part of this website refresh, I found Motion.dev to be very helpful for the animations.",
      link: "https://motion.dev/",
      linkText: "Read More on Motion.dev",
      cardImage: "motion.png"
    },
  ];

  return (
    <>
      <Header />
      <div className="page-content">
        <div className="software-engineering-wrapper">
          <AnimatePresence initial={false}>
              <motion.div
                key="terminal"
                className="terminal-container"
                variants={terminalVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                <motion.p className="terminal-text">
                  {typedText}
                  <span className="cursor" />
                </motion.p>
              </motion.div>
          </AnimatePresence>

          <AnimatePresence initial={false}>
            {showCards && (
              <motion.section
                key="cards"
                className="articles"
                variants={cardVariants}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                {cardData.map((card, index) => (
                  <motion.article
                    key={index}
                    custom={index}
                    variants={cardVariants}
                  >
                    <div className="article-wrapper">
                      <figure>
                        <img src={card.cardImage} alt="" />
                      </figure>
                      <div className="article-body">
                        <h2>{card.title}</h2>
                        <p>
                          {card.description}
                        </p>
                        <a href={card.link} target="_blank" rel="noopener noreferrer" className="read-more">
                          {card.linkText}
                          <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </motion.article>
                ))}
              </motion.section>
            )}
          </AnimatePresence>
        </div>
      </div>
    </>
  );
};

export default Playground;